import { useQuery } from '@tanstack/react-query';
import { buscarConfiguracaoPublica, buscarMe } from './api';

/** `GET /v1/publico/configuracao` — cacheado, sem auth. Alimenta rodapé, aviso de
 *  campanha, termos e a mensagem de compartilhar (brinde do indicado). */
export function useConfiguracaoPublica() {
  return useQuery({
    queryKey: ['publico', 'configuracao'],
    queryFn: buscarConfiguracaoPublica,
    staleTime: 5 * 60_000,
  });
}

/** `GET /v1/me` — dados do cliente + crescimento derivado (tudo da API). */
export function useMe() {
  return useQuery({ queryKey: ['me'], queryFn: buscarMe });
}
